import React, { memo } from "react";
import { Link } from "react-router-dom";
import type { DiscoverPageItemDetail } from "@highnote/server/src/functions/handlers/discover/types";
import { getSpaceUrl } from "../shared";
import { Byline } from "../Byline";
import "./styles.scss";

export const HeroSpaceTile = memo(
  ({ itemDetail }: { itemDetail: DiscoverPageItemDetail | null }) => {
    const url = itemDetail?.entityId
      ? getSpaceUrl(itemDetail.entityId, itemDetail.shareKey)
      : null;
    const imageUrl =
      itemDetail?.coverImageUrl ?? itemDetail?.squareImageUrl ?? null;

    const content = (
      <div className="hero-space-tile">
        <div className="hero-space-tile-image">
          {imageUrl && <img src={imageUrl} alt={itemDetail?.title ?? ""} />}
        </div>
        <div className="hero-space-tile-info">
          {itemDetail?.title && (
            <span className="hero-space-tile-name">{itemDetail.title}</span>
          )}
          {itemDetail?.createdByName && (
            <Byline
              picture={itemDetail.createdByPicture}
              name={itemDetail.createdByName}
            />
          )}
        </div>
      </div>
    );

    if (url) {
      return (
        <Link to={url} className="hero-space-tile-link">
          {content}
        </Link>
      );
    }

    return content;
  },
);
HeroSpaceTile.displayName = "HeroSpaceTile";
